import { getCarAnnualApproveList,getCarApproveProgressList,submitCarAudit } from "../../api/config/modules/VehicleAnnualReview";

const state = {
    getCarAnnualApproveList: {},
    getCarApproveProgressList: {},
    submitCarAudit: {}
};

const mutations = {
  SET_GETCARANNUALAPPROVELIST: (state, getCarAnnualApproveList) => {
    state.getCarAnnualApproveList = getCarAnnualApproveList;
  },
  SET_GETCARAPPROVEPROGRESSLIST: (state, getCarApproveProgressList) => {
    state.getCarApproveProgressList = getCarApproveProgressList;
  },
  SET_SUBMITCARAUDIT: (state, submitCarAudit) => {
    state.submitCarAudit = submitCarAudit;
  },
};

const actions = {
  GET_GETCARANNUALAPPROVELIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getCarAnnualApproveList(data).then((res) => {
          commit("SET_GETCARANNUALAPPROVELIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCARAPPROVEPROGRESSLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getCarApproveProgressList(data).then((res) => {
          commit("SET_GETCARAPPROVEPROGRESSLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SUBMITCARAUDIT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        submitCarAudit(data).then((res) => {
          commit("SET_SUBMITCARAUDIT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
